import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d7106fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", {
  class: "block-opener",
  style: {"list-style-type":"'⚙️'"}
}, null, -1))
const _hoisted_2 = { class: "option" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "🍅 Number of pomodori by cycle", -1))
const _hoisted_4 = { class: "stat-selector" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "option" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "🎯 Pomodori goal", -1))
const _hoisted_8 = { class: "stat-selector" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "option" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "✨ Gradiant background", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, null, -1))
const _hoisted_15 = { class: "option" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "🔉 Sound effect", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, null, -1))
const _hoisted_18 = { class: "option" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", { class: "info-label block-opener" }, "⏲️ Timer options (in minutes)", -1))
const _hoisted_20 = { class: "option" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Pomodoro", -1))
const _hoisted_22 = { class: "stat-selector" }
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "option" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Small break", -1))
const _hoisted_27 = { class: "stat-selector" }
const _hoisted_28 = { class: "info-value" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "option" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Big break", -1))
const _hoisted_32 = { class: "stat-selector" }
const _hoisted_33 = { class: "info-value" }
const _hoisted_34 = ["disabled"]

import { useParameters } from '@/store/Parameters'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionsBlock',
  props: {
  showTodo: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const store = useParameters()



const { pomodoroTime, breakTime, audioEnabled, gradiantEnabled, pomodoriByCycle, goal } = storeToRefs(store)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("details", null, [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(pomodoriByCycle)), 1),
            _createElementVNode("button", {
              class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(pomodoriByCycle) == 1, 'enabled-selector': _unref(pomodoriByCycle) != 1, 'disabled-selector': _unref(pomodoriByCycle) == 1 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (pomodoriByCycle.value -= 1))
            }, "-", 2),
            _createElementVNode("button", {
              class: "stat-selector-button enabled-selector",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (pomodoriByCycle.value += 1))
            }, "+")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(goal)), 1),
            _createElementVNode("button", {
              class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(goal) == 0, 'enabled-selector': _unref(goal) != 0, 'disabled-selector': _unref(goal) == 0 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ( goal.value -= 1)),
              disabled: _unref(goal) == 0
            }, "-", 10, _hoisted_10),
            _createElementVNode("button", {
              class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(goal) == 100, 'enabled-selector': _unref(goal) != 100, 'disabled-selector': _unref(goal) == 100 }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ( goal.value += 1)),
              disabled: _unref(goal) == 100
            }, "+", 10, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "stat-selector stat-selector-button enabled-selector checkbox-selector",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(gradiantEnabled) ? (gradiantEnabled).value = $event : null))
          }, null, 512), [
            [_vModelCheckbox, _unref(gradiantEnabled)]
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "stat-selector stat-selector-button enabled-selector checkbox-selector",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(audioEnabled) ? (audioEnabled).value = $event : null))
          }, null, 512), [
            [_vModelCheckbox, _unref(audioEnabled)]
          ]),
          _hoisted_17
        ]),
        _createElementVNode("details", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(pomodoroTime).minutes), 1),
                _createElementVNode("button", {
                  class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(pomodoroTime).minutes == 1, 'enabled-selector': _unref(pomodoroTime).minutes != 1, 'disabled-selector': _unref(pomodoroTime).minutes == 1 }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(pomodoroTime).minutes -= 1)),
                  disabled: _unref(pomodoroTime).minutes == 0
                }, "-", 10, _hoisted_24),
                _createElementVNode("button", {
                  class: "stat-selector-button enabled-selector",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(pomodoroTime).minutes += 1))
                }, "+")
              ])
            ]),
            _createElementVNode("li", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(breakTime).small.minutes), 1),
                _createElementVNode("button", {
                  class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(breakTime).small.minutes == 1, 'enabled-selector': _unref(breakTime).small.minutes != 1, 'disabled-selector': _unref(breakTime).small.minutes == 1 }]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(breakTime).small.minutes -= 1)),
                  disabled: _unref(breakTime).small.minutes == 0
                }, "-", 10, _hoisted_29),
                _createElementVNode("button", {
                  class: "stat-selector-button enabled-selector",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(breakTime).small.minutes += 1))
                }, "+")
              ])
            ]),
            _createElementVNode("li", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(breakTime).big.minutes), 1),
                _createElementVNode("button", {
                  class: _normalizeClass(["stat-selector-button", { 'disabled': _unref(breakTime).big.minutes == 1, 'enabled-selector': _unref(breakTime).big.minutes != 1, 'disabled-selector': _unref(breakTime).big.minutes == 1 }]),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(breakTime).big.minutes -= 1)),
                  disabled: _unref(breakTime).big.minutes == 0
                }, "-", 10, _hoisted_34),
                _createElementVNode("button", {
                  class: "stat-selector-button enabled-selector",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(breakTime).big.minutes += 1))
                }, "+")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      id: "open-todo-button",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:showTodo', !__props.showTodo)))
    }, "🧾")
  ]))
}
}

})